<template>
  <div v-if="detailsData.data">
    <div>
      <div class="Wcenter">
        <div class="top">
          <div class="imgBox">
            <img
              v-if="detailsData.data.cover"
              v-lazy="`${$global.imgUrl}/${detailsData.data.cover}`"
              alt=""
            />
            <img
              v-else
              v-lazy="require('@/assets/img/qietu/zz_default.png')"
              alt=""
              style="width: 80%; height: 80%; object-fit: contain"
            />
          </div>
          <div style="flex: 1">
            <h1
              v-if="detailsData.data.monographName"
              class="title"
              v-html="detailsData.data.monographName"
            ></h1>
            <div v-if="detailsData.data.monographAuthor" class="tips">
              作者：<span>{{ detailsData.data.monographAuthor }}</span>
            </div>
            <div
              class="tips"
              v-if="
                detailsData.data.translatorJson &&
                detailsData.data.translatorJson.length > 0
              "
            >
              译者：<span>{{
                detailsData.data.translatorJson.toString()
              }}</span>
            </div>
            <div v-if="detailsData.data.press" class="tips">
              出版单位：{{ detailsData.data.press }}
            </div>
            <div
              v-if="
                detailsData.data.pageNumber ||
                detailsData.data.monographLenght ||
                detailsData.data.isbn
              "
              class="tips"
            >
              <span v-if="detailsData.data.edition"
                >版次：{{ detailsData.data.edition }}</span
              >
              <span v-if="detailsData.data.pageNumber"
                >页数：{{ detailsData.data.pageNumber }}</span
              >
              <span v-if="detailsData.data.monographLenght"
                >字数：{{ detailsData.data.monographLenght }}</span
              >
              <span v-if="detailsData.data.isbn"
                >ISBN：{{ detailsData.data.isbn }}</span
              >
            </div>
            <div class="tips">
              <span v-if="detailsData.data.showPublishTime"
                >出版时间：{{ detailsData.data.showPublishTime }}</span
              ><span v-if="detailsData.data.classifyNumber"
                >中图分类号：{{ detailsData.data.classifyNumber }}</span
              >
            </div>
          </div>
        </div>
        <ul v-if="detailsData.data.artSummary" class="content">
          <li>
            <span class="value"
              >内容简介：<span
                class="detail"
                v-html="detailsData.data.artSummary"
              ></span
            ></span>
          </li>
        </ul>
      </div>
      <div class="Wbottom">
        <div class="nav">
          <div @click="changeAct(0)" :class="act === 0 ? 'active' : ''">
            目录
            <span v-show="act === 0" class="xian"></span>
          </div>
        </div>
        <div class="mulu" v-show="act === 0">
          <div class="oneUl" v-html="detailsData.data.catalogue"></div>
        </div>
      </div>
    </div>
    <!-- <LookUpTheWord @CloseToRetrieve="CloseToRetrieve" :coord='coord' v-if="isCheck" /> -->
  </div>
</template>

<script>
// import LookUpTheWord from '../../../../components/pager/lookUpTheWord.vue'
export default {
  name: "center",
  props: ["detailsData"],
  data() {
    return {
      act: 0,
      // isCheck:false,
      // coord:{
      //   x:0,
      //   y:0,
      //   text:''
      // }
    };
  },
  // components:{LookUpTheWord},
  //   watch:{
  //   //监视词条
  //   'coord.text':{ //如果有内容则显示组件
  //     immediate:true, //立即执行
  //     handler(){
  //       if(this.coord.text && !/^\s+$/.test(this.coord.text)){
  //       this.isCheck=true
  //     }
  //     }
  //   }
  // },
  methods: {
    // 鼠标按下
    // lookDown(){
    //   this.isCheck=false //关闭检索组件
    // },
    // // 鼠标抬起
    // lookUp(event){
    //   this.coord.x= event.clientX //水平坐标
    //   this.coord.y = event.clientY //垂直坐标
    //   this.coord.text=window.getSelection().toString() //选中的文本
    // },
    // CloseToRetrieve(){ //关闭按钮
    //   this.isCheck=false //关闭组件
    // },
    changeAct(i) {
      this.act = i;
    },
  },
};
</script>
<style lang="scss" scoped>
.Wcenter {
  width: 792px;
  //height: 513px;
  padding: 32px 34px 45px;
  background: #ffffff;
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  border: 1px solid #a3cbe7;
  border-radius: 10px;

  .content {
    width: 724px;
    margin: 25px auto 0;

    li {
      margin-top: 5px;

      .key {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        //background: yellow;
        color: #333333;
        margin-right: 12px;
      }

      .value {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        .detail {
          &::v-deep img {
            max-width: 100% !important;
            height: auto;
          }
        }
      }
    }
  }

  .top {
    display: flex;
    //justify-content: space-between;
    .imgBox {
      width: 150px;
      height: 150px;
      background: #f4f4f4;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      //background: pink;
      //float: left;
    }

    .title {
      //float: left;
      margin-left: 11px;
      font-size: 30px;
      font-weight: bold;
      color: #263d78;
      margin-top: -8px;
    }

    .tips {
      margin-left: 11px;
      //width: 666px;
      //height: 16px;
      font-size: 14px;
      //font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333 !important;
      line-height: 30px;
      span {
        margin-left: 10px;
        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
}

.Wbottom {
  width: 792px;
  margin-top: 10px;
  padding: 34px;
  //height: 803px;
  background: #ffffff;
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  border: 1px solid #a3cbe7;
  border-radius: 10px;

  .nav {
    display: flex;
    cursor: pointer;
    div {
      margin-right: 50px;
      width: 80px;
      height: 20px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
    }

    .active {
      width: 80px;
      height: 20px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0b35c5;
      line-height: 24px;
      position: relative;
    }

    .xian {
      position: absolute;
      width: 40px;
      left: 0;
      bottom: -10px;
      height: 3px;
      background: #0b35c5;
      border-radius: 1px;
    }
  }

  .daodu {
    margin-top: 40px;
    //text-indent: 30px;
    min-height: 400px;
  }

  .mulu {
    .oneUl {
      word-wrap: break-word;
      // text-indent: 20px;
      margin-top: 40px;

      &::v-deep video,
      &::v-deep img {
        max-width: 100% !important;
        height: auto;
      }
      .oneLi {
        width: 160px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        //position: relative;
        .zhang {
          margin-right: 10px;
        }

        .twoUl {
          margin-left: 32px;
          margin-top: 30px;
          margin-bottom: 50px;
          //position: absolute;
          //right: 0;
          li {
            width: 197px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 36px;
          }

          .jie {
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
